module.exports = __webpack_public_path__ + "img/people5.da1f6084.png";